import {Component, OnInit} from '@angular/core';
import {getAppThemeName} from "./core/functions/common.function";
import {CommonService} from "./shared/services/common.service";
import {IrreversibleOperationBannerHeaderComponent} from "./shared/components/header/irreversible-operation-banner/irreversible-operation-banner.header.component";
import {DBHeaderComponent} from "./shared/components/header/db/db.header.component";
import {PbHeaderComponent} from "./shared/components/header/pb/pb.header.component";
import {NbHeaderComponent} from "./shared/components/header/nb/nb.header.component";
import {FooterComponent} from "./shared/components/footer/footer.component";
import {RouterModule} from "@angular/router";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    IrreversibleOperationBannerHeaderComponent,
    DBHeaderComponent,
    PbHeaderComponent,
    NbHeaderComponent,
    FooterComponent
  ]
})
export class AppComponent implements OnInit {
  title = 'consent-ui';
  favIcon: HTMLLinkElement | null;

  constructor(
    protected appService: CommonService
  ) {
    this.favIcon = document.querySelector('#favIcon');
    if (this.favIcon !== null) {
      this.favIcon.href = `./assets/favicon-${getAppThemeName()}.${getAppThemeName() === 'pb' ? 'svg' : 'ico'}`;
    }
  }

  ngOnInit(): void {
    if (this.favIcon !== null) {
      this.favIcon.href = `./assets/favicon-${getAppThemeName()}.${getAppThemeName() === 'pb' ? 'svg' : 'ico'}`;
    }
  }


  protected readonly getAppThemeName = getAppThemeName;
}
